import React from "react";
import { Salad } from "lucide-react";
import AlimentazioneControllo from "../components/AlimentazioneControllo";

export default function NonMangia() {
  return (
    <AlimentazioneControllo
      tipo="mangia"
      title="Non mangia"
      subtitle="Controlla che ogni ospite mangi. Segnala solo chi non ha mangiato, indicando i pasti saltati e una nota."
      Icon={Salad}
      momentiOptions={["Colazione", "Pranzo", "Merenda", "Cena"]}
      momentiLabel="Quali pasti ha saltato"
      verbo="mangiato"
      flebiOptions={[{ v: "parenterale", l: "Nutrizione parenterale (flebo)" }, { v: "integratore", l: "Integratore/sacca nutrizionale" }, { v: "altro", l: "Altro" }]}
      flebiLabel="Nutrizione assistita"
      testid="non-mangia"
    />
  );
}
